function Blog() {
  return (
    <div className="max-w-5xl mx-auto py-20 px-6">

      <h1 className="text-3xl font-bold mb-6">RentEase Blog</h1>

      <div className="space-y-6">

        <div>
          <h2 className="text-xl font-semibold">
            5 Benefits of Renting Furniture
          </h2>
          <p className="text-gray-600">
            Renting furniture helps save money and allows flexibility.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold">
            Best Furniture for Small Apartments
          </h2>
          <p className="text-gray-600">
            Learn how to optimize space with modern furniture.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold">
            Why Renting Appliances is Smart
          </h2>
          <p className="text-gray-600">
            Renting appliances can reduce upfront costs.
          </p>
        </div>

      </div>

    </div>
  );
}

export default Blog;
